(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Greenbrier",
                {
                    url: "/Greenbrier",
                    component: "greenbrier",
                    PageTitle: "Greenbrier 2019",
                    requiredPermissions: "Greenbrier:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("greenbrier",
        {
            templateUrl: "App/Resources/Greenbrier/greenbrier.html",
            controller: greenbrierCtrl,
            bindings: {
                states: "<"
            }
        });

    greenbrierCtrl.$inject = ["amplitudeService"];

    function greenbrierCtrl(amplitudeService) {
        var $ctrl = this;


        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
       
    }
})(window.app, window.angular); // jshint ignore:line